export default __webpack_public_path__ + "static/media/regulatory--horn--g1.77ed51fc.png";